// src/pages/SOPDocuments.js
import React, { useEffect, useState } from "react";

const SOPDocuments = ({ isAdmin }) => {
	const [documents, setDocuments] = useState([]);
	const [loading, setLoading] = useState(true);
	const [newLink, setNewLink] = useState({ name: "", url: "" });
	const API = process.env.REACT_APP_API_URL;

	const fetchDocs = () => {
		setLoading(true);
		fetch(`${API}/sop-documents`)
			.then((res) => res.json())
			.then((data) => {
				const safe = Array.isArray(data) ? data : [];
				setDocuments(safe);
			})
			.catch((err) => console.error("Error fetching SOP documents:", err))
			.finally(() => setLoading(false));
	};

	useEffect(() => {
		fetchDocs();
	}, []);

	const handleUpload = async (e) => {
		e.preventDefault();
		const file = e.target.file.files[0];
		if (!file) return;

		const formData = new FormData();
		formData.append("file", file);

		await fetch(`${API}/sop-documents/upload`, {
			method: "POST",
			body: formData,
		});

		e.target.reset();
		fetchDocs();
	};

	const handleDeleteDoc = async (name) => {
		if (!window.confirm(`Delete ${name}?`)) return;

		await fetch(`${API}/sop-documents/${encodeURIComponent(name)}`, {
			method: "DELETE",
		});

		fetchDocs();
	};

	const handleAddLink = async (e) => {
		e.preventDefault();
		if (!newLink.name || !newLink.url) return;

		await fetch(`${API}/sop-documents/links`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(newLink),
		});

		setNewLink({ name: "", url: "" });
		fetchDocs();
	};

	const handleDeleteLink = async (id) => {
		if (!window.confirm("Delete this link?")) return;

		await fetch(`${API}/sop-documents/links/${id}`, {
			method: "DELETE",
		});

		fetchDocs();
	};

	return (
		<div className="sop-documents">
			<h1 className="text-gray">Resources Portal</h1>

			{/* Example one-off static tile */}

			{isAdmin && (
				<div className="admin-controls mb-4">
					<h3>Admin Controls</h3>

					{/* Upload form */}
					<form onSubmit={handleUpload}>
						<input type="file" name="file" required />
						<button type="submit">Upload</button>
					</form>

					{/* Add link form */}
					<form onSubmit={handleAddLink} className="mt-2">
						<input
							type="text"
							placeholder="Link Name"
							value={newLink.name}
							onChange={(e) =>
								setNewLink((prev) => ({ ...prev, name: e.target.value }))
							}
							required
						/>
						<input
							type="url"
							placeholder="https://..."
							value={newLink.url}
							onChange={(e) =>
								setNewLink((prev) => ({ ...prev, url: e.target.value }))
							}
							required
						/>
						<button type="submit">Add Link</button>
					</form>
				</div>
			)}

			<div className="file-list-container">
				{loading ? (
					<p>Loading...</p>
				) : documents.length > 0 ? (
					documents.map((doc, index) => (
						<div className="file-item" key={`${doc.name || doc.id}-${index}`}>
							<span className="file-name">
								{doc.name}{" "}
								{doc.kind === "link" ? (
									<span className="badge badge-info">🔗 Link</span>
								) : (
									<span className="badge badge-secondary">📄 File</span>
								)}
							</span>
							<div className="file-actions">
								{doc.kind === "link" ? (
									<>
										<a
											href={doc.url}
											target="_blank"
											rel="noopener noreferrer"
											className="view-button"
										>
											Open
										</a>
										{isAdmin && (
											<button
												className="delete-button"
												onClick={() => handleDeleteLink(doc.id)}
											>
												Delete
											</button>
										)}
									</>
								) : (
									<>
										{/* doc.url is a 15-min user-delegation SAS URL from
										    the backend list endpoint — no auth needed on the
										    request itself. Anchors can't attach the Authorization
										    header that our /view and /download endpoints require,
										    so we go straight to blob storage. */}
										<a
											href={doc.url}
											target="_blank"
											rel="noopener noreferrer"
											className="view-button"
										>
											View
										</a>
										<a
											href={doc.url}
											download={doc.name}
											className="download-button"
										>
											Download
										</a>
										{isAdmin && (
											<button
												className="delete-button"
												onClick={() => handleDeleteDoc(doc.name)}
											>
												Delete
											</button>
										)}
									</>
								)}
							</div>
						</div>
					))
				) : (
					<p>No documents available.</p>
				)}
			</div>
		</div>
	);
};

export default SOPDocuments;
